'use strict';

import anywhereTemplate from './anywhere.html';
import { UAParser } from 'ua-parser-js';

var anywhereController = function ($window, $controller, $state, anywhereService, activityService, loggingService, $location, workflowService) {
    var vm = this;
    angular.extend(vm, $controller('baseStepController'));

    //controller state
    vm.showSpinner = true;
    vm.loading = true;
    vm.unityInstance = null;
    vm.anywhereSettings = null;
    vm.videoSourceUrl = null;
    vm.preloadStoreManifestUrl = null;
    vm.doPreload = true;
    vm.preloadUrls = [];
    vm.runStoreUrl = "";

    const ResearchPlayerType = {
        WebGL: 'WebGL',
        Mobile: 'Mobile'
    };

    vm.$onInit = function () {

        if (vm.$stateParams.mobileComplete == 'true') {
            vm.completeAnywhereMobile();
            return;
        }

        if (vm.$stateParams.ticketId == undefined || vm.$stateParams.stepId == undefined) {
            // try and get a local Cookie for the ticket and step
            let ticketId = getCookie("ticketId");
            let stepId = getCookie("stepId");

            // if we do not have a cookie to use then go to error screen
            if (ticketId == "" || stepId == "") {
                $state.go('error');
                return;
            }

            // if we have cookies then refresh this page with the cookies
            $state.go(
                'anywhere',
                {
                    ticketId: ticketId, // New id/$stateParams go here
                    stepId: stepId
                },
                {
                    location: true, // This makes it update URL
                    inherit: true,
                    relative: $state.$current,
                    notify: false // This makes it not reload
                }
            );
            return;
        }

        vm.initializeStep(vm.$stateParams).then(function (executionStep) {
            vm.executionStep = executionStep;

            if (executionStep == undefined) {
                $state.go('error');
                return;
            }
            setCookie("ticketId", vm.$stateParams.ticketId, 1);
            setCookie("stepId", vm.$stateParams.stepId, 1);

            let parser = new UAParser();
            let device = parser.getDevice().type;
            let os = parser.getOS().name;
            let browser = parser.getBrowser().name;

            let isiOS = (os == 'iOS' // Is an Iphone or old Ipad
                || (os == "Mac OS" &&
                    (navigator.maxTouchPoints > 1 // Is an Ipad (Apple likes to think IPad's are small computers with touch control and not tablets) https://stackoverflow.com/questions/58019463/how-to-detect-device-name-in-safari-on-ios-13-while-it-doesnt-show-the-correct
                        || window.orientation != undefined))); // Ipad is seen as Mac OS and window.orientation is not supported on desktop: https://github.com/faisalman/ua-parser-js/issues/387

            if (device == 'mobile' // Is a Mobile device
                || device == 'tablet' // Is a Tablet
                || isiOS) // Is iOS device
            {
                vm.initializeAnywhereMobile(isiOS && (browser == "Safari" || browser == "Mobile Safari"));
            }
            else {
                vm.initializeAnywhere();
            }
        });
    };

    vm.setViewSpace = function () {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);

        let vw = window.innerWidth * 0.01;
        document.documentElement.style.setProperty('--vw', `${vw}px`);
    };

    vm.initializeAnywhereMobile = function (useUniversalLink) {
        vm.info('anywhere.component: initialized Mobile');

        var ticketStep = vm.executionStep.ticketStep;

        // activate Mobile UI
        var moblieInfo = document.querySelector("#moblieInfo");
        moblieInfo.style.display = "block";

        // turn off spinners
        var canvas = document.querySelector("#unity-container");
        var loader = document.querySelector("#unity-loader");
        var spinner = document.querySelector("#unity-spinner");
        canvas.style.display = "none";
        loader.style.display = "none";
        spinner.style.display = "none";

        anywhereService.getAnywhereLaunchSettings(ticketStep.id, ticketStep.ticketId, ResearchPlayerType.Mobile).then((returnedSettings) => {

            vm.anywhereSettings = returnedSettings;

            vm.runStoreUrl = "";
            var currentUrl = window.location.href;
            var currentUrlwithSettings = "";
            if (!currentUrl.includes("?settingsUrl=")) {
                var currentUrlwithSettings = currentUrl + "?settingsUrl=" + encodeURIComponent(vm.anywhereSettings.settingsUrl);
            }
            else {
                var currentUrlwithSettings = currentUrl;
            }

            var runstoreUrl = currentUrlwithSettings;
            if (useUniversalLink) // if we are on iOS and are on Safari we use Apples Universal Links to launch the app
            {
                runstoreUrl = currentUrlwithSettings.replace("run", "mobile");
                vm.runStoreUrl = currentUrlwithSettings.replace("run", "mobile");
            }
            else // if we are not on iOS and are not on Safari we use deep links to launch the app
            {
                runstoreUrl = currentUrlwithSettings.replace(/https/, "runstore");
                vm.runStoreUrl = runstoreUrl;
            }

            window.open(runstoreUrl, "_self");
        });
    }

    vm.completeAnywhereMobile = function () {
        workflowService.getTicketStepWithTicketStepID(vm.$stateParams.ticketId, vm.$stateParams.ticketStepId).then((ticketStep) => {
            vm.transition(vm.$stateParams.ticketId, ticketStep);
        });
    }

    vm.initializeAnywhere = function () {

        vm.info('anywhere.component: initialized');

        var technicallySupported = vm.testTechnicalSpecs();

        var ticketStep = vm.executionStep.ticketStep;

        vm.setViewSpace();

        $window['fireAngularEvent'] = (eventName, args) => {
            if (eventName === 'onInContextTelemetry') {
                vm.logUnityEvent(args);
            }

            if (eventName === 'onAnywhereClosed') {
                vm.info('anywhere.component: onAnywhereClosed fired')
                vm.onAnywhereClosed();
            }

            if (eventName === 'onAnywhereRetryableError') {
                vm.info('anywhere.component: onAnywhereRetryableError fired')
                vm.onAnywhereRetryableError();
            }

            if (eventName === 'onAnywhereError') {
                vm.info('anywhere.component: onAnywhereError fired')
                vm.error(new Error(args), false);
                vm.isFail = true;
            }

            if (eventName === 'onAnywherePlayVideo') {
                vm.info('anywhere.component: onAnywherePlayVideo fired')
                vm.playVideo();
            }

            if (eventName === 'onAnywhereStartPreload') {
                vm.info('anywhere.component: onAnywhereStartPreload fired')
                vm.preload(args);
            }

            if (eventName === 'onAnywhereStopPreload') {
                vm.info('anywhere.component: onAnywhereStopPreload fired')
                vm.doPreload = false;
            }
        };

        anywhereService.getAnywhereLaunchSettings(ticketStep.id, ticketStep.ticketId, ResearchPlayerType.WebGL).then((returnedSettings) => {

            vm.anywhereSettings = returnedSettings;

            vm.videoSourceUrl = vm.anywhereSettings.fullFlyinVideoUrl;
            vm.preloadStoreManifestUrl = vm.anywhereSettings.preloadStoreUrl;

            var buildUrl = vm.anywhereSettings.playerUrl + '/Build';

            $location.search('settingsUrl', vm.anywhereSettings.settingsUrl);

            var unityConfig = {
                dataUrl: buildUrl + "/unitybuild.data.gz",
                frameworkUrl: buildUrl + "/unitybuild.framework.js.gz",
                codeUrl: buildUrl + "/unitybuild.wasm.gz"
            };

            //This code is used for local debugging.
            //var localPort = 63346;

            //var unityConfig = {
            //dataUrl: 'http://localhost:' + localPort + '/Build/webglbuild.data.gz',
            //frameworkUrl: 'http://localhost:' + localPort + '/Build/webglbuild.framework.js.gz',
            //codeUrl: 'http://localhost:' + localPort + '/Build/webglbuild.wasm.gz'
            //};

            var canvas = document.querySelector("#unity-canvas");
            var loader = document.querySelector("#unity-loader");
            var spinner = document.querySelector("#unity-spinner");
            var progressBar = document.querySelector("#unity-progress-bar");
            var progressBarFull = document.querySelector("#unity-progress-bar-full");

            var script = document.createElement("script");
            script.src = buildUrl + "/unitybuild.loader.js";
            script.crossOrigin = "anonymous";
            script.onload = () => {
                $window.createUnityInstance(canvas, unityConfig, (progress) => {
                    spinner.style.display = "none";
                    progressBar.style.display = "block";
                    progressBarFull.style.width = 100 * progress + "%";
                }).then((unityInstance) => {
                    loader.style.display = "none";
                    vm.unityInstance = unityInstance;
                }).catch((message) => {
                    alert(message);
                });
            };
            document.body.appendChild(script);
        });
    };

    vm.onAnywhereRetryableError = function () {
        loggingService.flush();
        vm.unityInstance.Quit();
        $state.go($state.current.name, $state.params, { reload: true });
    };

    vm.onAnywhereClosed = function () {
        loggingService.flush();
        return activityService.flush().then(() => {
            vm.unityInstance.Quit();
            vm.transition();
        });
    };

    vm.logWindowClosed = function () {
        vm.info('anywhere.component: pagehide called')
    };

    // 'unload' is blocked by permissions policy here and never fires, so the page teardown was
    // going unlogged. 'pagehide' is the supported replacement and also covers bfcache entry.
    $window.addEventListener('pagehide', vm.logWindowClosed);

    $window.onresize = vm.setViewSpace;

    // How long to wait for the fly-in video's metadata before giving up on it entirely, and how
    // much slack to allow past its real runtime once we know the duration.
    const VIDEO_METADATA_TIMEOUT_MS = 15000;
    const VIDEO_OVERRUN_SLACK_MS = 10000;

    vm.playVideo = function () {

        var video = document.querySelector("#anywhereVideoFrame");
        var dismissed = false;
        var watchdog = null;

        // Unity does not wait for us: it fires onAnywherePlayVideo and immediately treats the
        // video as finished (ResearchVideoPlaybackSceneBindingView.Bind), advancing straight to
        // the shopping step. So if this overlay is not taken down the participant is stranded on
        // the fly-in frame with a fully loaded store running behind it and no way out but a
        // refresh. Every failure path has to dismiss, not just a clean 'ended'.
        var dismiss = function (reason) {
            if (dismissed) {
                return;
            }
            dismissed = true;

            clearTimeout(watchdog);
            video.style.display = 'none';
            vm.info('anywhere.component: playVideo: dismissed ({reason})', { reason: reason });
        };

        var armWatchdog = function (milliseconds) {
            clearTimeout(watchdog);
            watchdog = setTimeout(function () { dismiss('watchdog'); }, milliseconds);
        };

        // Until metadata arrives we have no duration to work from, so start with a short fixed
        // timeout that catches a video which never loads at all, then extend it to the real
        // runtime once we know it.
        armWatchdog(VIDEO_METADATA_TIMEOUT_MS);

        video.onloadedmetadata = function () {
            if (isFinite(video.duration)) {
                armWatchdog(video.duration * 1000 + VIDEO_OVERRUN_SLACK_MS);
            }
        };

        video.onended = function () { dismiss('ended'); };
        video.onerror = function () { dismiss('error'); };

        video.style.display = 'block';

        // A rejected play() (autoplay refusal, decode failure, src never resolved) leaves the
        // element parked on frame zero and 'ended' never comes.
        var playback = video.play();
        if (playback && playback.catch) {
            playback.catch(function (error) { dismiss('play rejected: ' + error.name); });
        }
    };

    vm.logUnityEvent = function (args) {
        var argsObject = angular.fromJson(args);

        var eventProperties = {};
        Object.keys(argsObject.Properties).forEach(key => {
            eventProperties[key] = argsObject.Properties[key].Value;
        });

        switch (args.Level) {
            case 3:
                loggingService.warn(argsObject.MessageTemplate.Text, eventProperties);
                break;
            case 4:
            case 5:
                loggingService.error(argsObject.MessageTemplate.Text, eventProperties);
                break;
            default:
                loggingService.info(argsObject.MessageTemplate.Text, eventProperties);
        }
    };

    vm.info = function (msg, props) {
        var enhancedProps = vm.enhanceProps(props);
        loggingService.info(msg, enhancedProps);
    };

    vm.warn = function (msg, props) {
        var enhancedProps = vm.enhanceProps(props);
        loggingService.warn(msg, enhancedProps);
    };

    vm.testTechnicalSpecs = function () {
        var hasSupport = false;
        var supportText = { 'webGL2Support': 'false' };

        // Test whether we have WebGL2 support by creating a canvas.
        const gl = document.createElement('canvas').getContext('webgl2');

        // It is possible to have WebGL2 support but not actually have a rendering
        // context due to drivers or hardware not supporting it.  If we have a context
        // but not a valid canvas, that's the culprit.
        if (!gl) {
            if (typeof WebGL2RenderingContext !== 'undefined') {
                supportText = { 'webGL2Support': 'supported but disabled due to drivers or hardware' };
            }
        } else {
            // We successfully created a canvas, we have WebGL2 support.
            supportText = { 'webGL2Support': 'true' };
            hasSupport = true;
        }

        vm.info('anywhere.component: testTechnicalSpecs: WebGL2 support: {support}', supportText);

        return hasSupport;
    };

    vm.enhanceProps = function (props) {

        props = props || {};

        props.ticketId = vm.executionStep.ticketStep.ticketId;
        props.studyId = vm.executionStep.ticketStep.studyId;
        props.ticketStepId = vm.executionStep.ticketStep.id;

        return props;
    };

    // FileNameHashPairs is keyed by texture format (ExportTextureFormats): NONE holds the shared
    // geometry/json pieces and DXT/ETC/PVRTC each hold that one format's texture pieces. Unity
    // only ever fetches NONE plus the single format it resolved (StoreLoader.OnStoreManifestFetched),
    // so flattening every format would preload roughly twice the bytes the store actually reads.
    // WebGL always resolves to DXT, and the mobile path returns before this component gets here.
    vm.getPreloadPieceFiles = function (storeManifest) {
        var fileNameHashPairs = (storeManifest || {}).FileNameHashPairs;

        if (fileNameHashPairs == null) {
            vm.warn('anywhere.component: preload: manifest had no FileNameHashPairs, skipping preload');
            return [];
        }

        var pieceFiles = [];
        ['NONE', 'DXT'].forEach(function (textureFormat) {
            if (Array.isArray(fileNameHashPairs[textureFormat])) {
                pieceFiles = pieceFiles.concat(fileNameHashPairs[textureFormat]);
            }
        });

        // Unity streams the pieces in FileIndex order, and dropping the other formats leaves gaps,
        // so sort by index rather than trusting the order the keys happen to come back in.
        return pieceFiles.sort(function (a, b) { return a.FileIndex - b.FileIndex; });
    };

    vm.preload = function (manifestVersion) {
        if (vm.preloadStoreManifestUrl == null) {
            return;
        }

        // Every tutorial step fires onAnywhereStartPreload, so build the versioned URL from the
        // pristine base each time. Rewriting vm.preloadStoreManifestUrl in place used to work
        // only on the first pass - afterwards there was no 'manifest.json' left to match and each
        // later step silently refetched the previous step's URL.
        var manifestUrl = vm.preloadStoreManifestUrl.replace('manifest.json', 'manifest-' + manifestVersion + '.json');

        // A previous step's queue may still hold entries it never got through before its
        // onAnywhereStopPreload arrived; this store's pieces are the only ones worth fetching now.
        vm.preloadUrls = [];
        vm.doPreload = true;

        // Parse this URL based on the following example: https://prod-anywhere.shoppermx.io/12345/12345-manifest-v9.json?sasquerystring
        anywhereService.getStoreManifest(manifestUrl).then(storeManifest => {
            var originalUrl = new URL(manifestUrl);
            var originalUrlPathSegments = originalUrl.pathname.split('/');
            var originalFilenamePath = originalUrlPathSegments[3]; // 12345-manifest-v9.json

            vm.getPreloadPieceFiles(storeManifest).forEach(function (fileNameHashPair) {
                var newUrl = originalUrl.href.replace(originalFilenamePath, fileNameHashPair.FileName); // e.g. replace 12345-manifest-v9.json with 12345-v9-2020-01-22-05-28-22-0.data.gz but leave the rest of the URL intact.

                vm.preloadUrls.push(newUrl);
            });

            vm.performNextPreloadDownload();

        }).catch(function (error) {
            // Preloading is a bandwidth optimization - the store still loads without it, so a
            // failure here must not surface to the participant or poison the step.
            vm.warn('anywhere.component: preload: could not prepare preload, continuing without it', { error: '' + error });
        });
    }

    vm.performNextPreloadDownload = function () {

        if (vm.doPreload) {
            var urlToPreload = vm.preloadUrls.shift();
            if (urlToPreload != undefined) {
                anywhereService.preload(urlToPreload).then(returnedData => {
                    vm.performNextPreloadDownload();
                });
            }
        }
    }

    function $e(selector) {
        return angular.element(document.getElementsByClassName(selector));
    }

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
};

anywhereController.$inject = ['$window', '$controller', '$state', 'anywhereService', 'activityService', 'loggingService', '$location', 'workflowService'];

export var anywhereComponent = {
    name: 'anywhere',
    template: anywhereTemplate,
    controller: anywhereController,
    controllerAs: 'vm',
    bindings: {
        $stateParams: '<'
    }
};

export var anywhereRoute = {
    name: 'anywhere',
    url: '/anywhere',
    component: 'anywhere'
};

export var anywhereMobileRoute = {
    name: 'anywhereMobile',
    url: '/anywhere/:ticketId/:ticketStepId/:mobileComplete',
    component: 'anywhere'
};

export var anywherMobileReturnRoute = {
    name: 'anywhereMobileReturn',
    url: '/anywhere',
    component: 'anywhere'
};